{
  "version": 1,
  "asset_id": "e6a22f7d-fb59-42f0-aa1a-3eafd4e2e7d1",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e6a22f7d-fb59-42f0-aa1a-3eafd4e2e7d1/support-group-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e6a22f7d-fb59-42f0-aa1a-3eafd4e2e7d1/support-group-800.webp",
  "original_filename": "support-group-800.webp",
  "size": 56644,
  "content_type": "image/webp",
  "created_at": "2026-10-04T23:43:35Z"
}
